import { useState } from 'react';
import { languageTabs } from '@/mocks/filmData';

export default function LanguageTabs() {
  const [active, setActive] = useState(languageTabs[0].id);
  const current = languageTabs.find((t) => t.id === active) ?? languageTabs[0];

  return (
    <section id="languages" className="scroll-mt-20 bg-background-50">
      <div className="px-5 md:px-10 py-14 md:py-20">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
            <i className="ri-translate-2 text-lg" aria-hidden="true"></i>
          </span>
          <span className="text-xs font-medium tracking-widest text-primary-700 uppercase">Language</span>
        </div>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">语言版本说明</h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
          点选下面的标签，查看中字、双语、国语与字幕在线四种方向的详细说明与使用建议。
        </p>

        <div
          role="tablist"
          aria-label="语言版本切换"
          className="mt-6 inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-100 border border-background-200"
        >
          {languageTabs.map((tab) => {
            const isActive = tab.id === active;
            return (
              <button
                key={tab.id}
                role="tab"
                aria-selected={isActive}
                type="button"
                onClick={() => setActive(tab.id)}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-primary-700'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-7">
              <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">{current.heading}</h3>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">{current.intro}</p>
            </div>
            <div className="lg:col-span-5">
              <ul className="space-y-3">
                {current.points.map((point) => (
                  <li key={point} className="flex items-start gap-3 text-sm text-foreground-700">
                    <span className="w-6 h-6 shrink-0 rounded-full bg-accent-100 text-accent-900 flex items-center justify-center mt-0.5">
                      <i className="ri-check-line text-sm" aria-hidden="true"></i>
                    </span>
                    <span className="leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}